<script>
import { mapActions } from "pinia";
import { newsStore } from "@/store/newsStore";

export default {
  props: {
    news: {
      type: Object,
    },
  },
  methods: {
    ...mapActions(newsStore, ['updateConsolidatedNewsList']),
  },
};
</script>

<template>
  <div>
    <router-link
      :to="{name: 'OrganizationView', params: {id: news.textParams[0]}}"
    >{{ news.textParams[1] }}
    </router-link>
    {{$t('news.template.proposal.publish.by.org.consolidated.different.p1')}} <a
      class="consolidated-news"
      href="#"
      @click.prevent="updateConsolidatedNewsList(news.stringChildIds)"
    >{{news.textParams[2]}}
      {{$t('news.template.proposal.publish.by.org.consolidated.different.p2')}}</a>
    {{$t('news.template.proposal.publish.by.org.consolidated.different.p3')}}
    {{news.textParams[3]}}
    {{$t('news.template.proposal.publish.by.org.consolidated.different.p4')}}
  </div>
</template>
